export enum OnboardingNames {
  FUNDRAISING_GOALS = "FUNDRAISING_GOALS",
  FUNDRAISING_GOALS_PROFILE = "FUNDRAISING_GOALS_PROFILE",
}
export enum OnboardingStatus {
  HIDDEN = "HIDDEN",
  COMPLETED = "COMPLETED",
}
